// removed by extract-text-webpack-plugin
module.exports = {"link":"index__link--2s-nb"};


//////////////////
// WEBPACK FOOTER
// ./src/client/shared-components/DocumentationLink/styles/index.scss
// module id = IM79
// module chunks = 23